export default "__VITE_ASSET__CP18JlU7__"